// extracted by mini-css-extract-plugin
export var container = "_57-0";
export var infoButton = "_57-1";
export var label = "_57-3";
export var labelExpanded = "_57-4";
export var price = "_57-5";
export var priceExpanded = "_57-6";
export var title = "_57-2";